import { useEffect } from 'react';
import { lazyRouteImporters } from '@/routes/config';

export const usePrefetchLazyRoutes = () => {
  useEffect(() => {
    const preload = () => {
      lazyRouteImporters.forEach((importer) => {
        importer().catch(() => {
          // ignore prefetch failures
        });
      });
    };
    if (typeof window === 'undefined') return;
    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(preload);
      return;
    }
    const timer = setTimeout(preload, 500);
    return () => clearTimeout(timer);
  }, []);
};
